export const environment = {
  production: true,
  staging: false,
  VERSION: require('../../package.json').version,
  apiEndPoint: 'https://customers.api.halodoc.com/alor-api',
  hostName: 'https://pharma.halodoc.com',
  withCredentials: true,
  firebase: {
    apiKey: 'AIzaSyClQeYxzgV1lmE_Y0ZOEHOwSgo04PgTJoU',
    authDomain: 'halodoc-1d02b.firebaseapp.com',
    databaseURL: 'https://halodoc-1d02b.firebaseio.com',
    projectId: 'halodoc-1d02b',
    storageBucket: 'halodoc-1d02b.appspot.com',
    messagingSenderId: '1037665135469',
    appId: '1:1037665135469:web:ed8e2bb96fe2733741c864',
    measurementId: 'G-KBR3WMGGBE',
  },
  gtmID: 'GTM-W4NK9B9',
  smoochConfig: {
    integrationId: '5e9c02efc905be000f039e4a',
  },
  mfeRemoteEntry: 'https://pharma.halodoc.com/alor-mfe/remoteEntry.json',
  authExpiryTimeInMillis: 1000 * 60 * 60 * 6, // 6 hours
  authRefreshThresholdInterval: 1000 * 60 * 20, // 20 mins
  cartExpiryTimeInMillis: 1000 * 60 * 10, // 10 min
  swUpdateTimeInMillis: 1000 * 60 * 60 * 1, // 1 hour
  authRefreshLimitCount: 2,
  pointRewardConfig: {
    tncUrl: 'https://marketing.halodoc.com/h4p-halopoints',
    rewardFAQUrl: 'https://marketing.halodoc.com/h4p-halopoints',
    settlementUrl: 'https://marketing.halodoc.com/h4p-halopoints',
  },
  kycConfig: {
    leadPageUrl: 'https://marketing.medisend.halodoc.com/panduan-kyc',
  },
  featureToggles: {
    b2bCategories: true,
    mercia_hilda_enabled: true,
  },
};
